import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectSortValues = (store: StoreSchema) => store.applications.sort